import React from "react";
import InfoTooltip from "app/components/common/InfoTooltip";
import "./InfoIconSlot.css";

// One delay for every note tooltip, so they open and close on the same timing.
export const TOOLTIP_DELAY = { show: 250, hide: 400 };

const InfoIconSlot = ({ text, iconClassName }) => (
  <span className="job-calendar-info-icon-slot">
    <InfoTooltip
      text={text}
      delay={TOOLTIP_DELAY}
      className="custom-tooltip"
      iconSize="20px"
      iconClassName={iconClassName}
    />
  </span>
);

export default InfoIconSlot;
